import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20.707 6.293a1 1 0 0 1 0 1.414l-10 10a1 1 0 0 1 -1.414 0l-5 -5a1 1 0 0 1 1.414 -1.414l4.293 4.293l9.293 -9.293a1 1 0 0 1 1.414 0","key":"svg-0"}]]

/**
 * IconCheckFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItY2hlY2siCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTIwLjcwNyA2LjI5M2ExIDEgMCAwIDEgMCAxLjQxNGwtMTAgMTBhMSAxIDAgMCAxIC0xLjQxNCAwbC01IC01YTEgMSAwIDAgMSAxLjQxNCAtMS40MTRsNC4yOTMgNC4yOTNsOS4yOTMgLTkuMjkzYTEgMSAwIDAgMSAxLjQxNCAwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/check-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCheckFilled = createReactComponent('filled', 'check-filled', 'CheckFilled', __iconNode);

export default IconCheckFilled;